export default __webpack_public_path__ + "2de735e7439bf86d3ccc944469ff02e4.svg";